<script>
	import { goto, url, metatags } from '@roxi/routify';
	import Image from 'svimg';
	import Navbar from "../components/Navbar.svelte";
	import { initializeApp } from "firebase/app";
	import { getAnalytics } from "firebase/analytics";

	// Firebase configuration
	const firebaseConfig = {
		apiKey: "AIzaSyA8jHE-PhrcnzNuvf_XQn3oiLsofTko_1g",
		authDomain: "padg-website.firebaseapp.com",
		projectId: "padg-website",
		storageBucket: "padg-website.appspot.com",
		messagingSenderId: "665350430157",
		appId: "1:665350430157:web:b3b1addd875f6c5fda7884",
		measurementId: "G-VBC2LX0S4B"
	};

	// Initialize Firebase
	const app = initializeApp(firebaseConfig);
	const analytics = getAnalytics(app);

	// General Metadata tags
	metatags.title = 'Palo Alto Data Group';
	metatags.description = 'Palo Alto Data Group Website';

	const products = [
        ['WORKFORCE VDC', './ref/WorkforceVDCicon.svg', 'PADG Icon',
			'https://drive.google.com/file/d/1W9PuYwDIjWaHp3r3QcfuJXm0LSkIbyfK/view?usp=sharing',
			'This 9-month, hybrid, project-based course educates its participants on key Virtual Design and Construction concepts so that the workforce can understand, collaborate, and apply VDC technology and principles.'],
        ['LEXOCAD', './ref/cadwork-favicon.png', 'LEXOCAD Icon',
			'https://07.cadwork.ch/index.php/de/',
			'Enabling everyone to benefit from the far-reaching advantages of effective 3D planning and visualization, through a simple, user-friendly and intuitive BIM software with innovative functionalities.'],
        ['WORKERS RIGHTS', './ref/WorkersApp.svg', 'PADG Icon',
			'https://play.google.com/store/apps/details?id=com.workersrightsstudio.workersrights',
			'Worker\'s App seeks to solve the information gap between workers and their rights, ensuring that everybody is informed about their protections in the workplace and who they should contact in case of violations.'],
		['ECPR DOWNLOADER', './ref/padg-icon-circle.svg', 'PADG Icon',
			'https://ecpr.io',
			'A tool to bulk download and categorize electronic certified payroll (eCPR) from the California Department of Industrial Relations, intended to assist with labor compliance investigations.'],
    ];
	let productExpanded = [true, false, false, false]

	const links = [
        ['about-padg', 'About'],
        ['products', 'Products'],
        ['contact', 'Contact']
    ];

	// smooth scroll 
	// https://stackoverflow.com/a/7717572
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});
</script>

<main id="main-container">
	<!--First Screen-->
	<div class="relative w-full min-h-screen">
		<div class="absolute flex flex-col w-full h-full z-20">
			<Navbar/>
			<div class="flex flex-auto flex-col space-y-14 lg:space-y-28 justify-center lg:pr-12 mx-[calc(6rem+0.1*(100%-768px))] font-sans text-gray-100">
				<p class="!leading-tight font-thin text-4xl lg:text-6xl"><b class="font-semibold">Palo Alto Data Group</b>	<br>Building better teams</p>
				<!-- <a href={'./about'} class="bg-palo-verde-light px-5 py-3 text-lg lg:px-10 lg:py-6 lg:text-xl w-max hover:no-underline">
					<a href="./#about-padg" class="text-blue-900">LEARN MORE</a>
				</a> -->
				<div class="invisible h-1/12"></div>
			</div>
		</div>
		<div class="color-filter">
			<Image class="absolute w-full h-full [&_img]:!h-full [&_img]:object-cover md:!hidden" src="./ref/header_bg_mobile.png" alt="A highway interchange with cars and a city skyline in the background" />
			<Image class="absolute w-full h-full [&_img]:!h-full [&_img]:object-cover !hidden md:!block" src="./ref/header_bg.png" alt="A highway interchange with cars and a city skyline in the background" />
		</div>
	</div>
	<!--Second Screen-->
	<div id="about-padg" class="w-full bg-gray-100 pb-8 lg:pb-0 lg:pt-4">
		<div class="relative flex flex-col items-center justify-center w-full h-auto min-h-[calc(100vh-2.5rem)] lg:min-h-screen space-y-10 lg:space-y-12 px-[calc(8rem+0.1*(100%-768px))]">
			<h1 class="mt-10 md:mt-6 font-roboto-slab font-light text-center text-4xl md:text-5xl text-palo-alto-dark">ABOUT <b class="font-semibold">PADG</b></h1>
			<div class="flex flex-row md:space-x-4 h-1/3 overflow-auto">
				<div class="flex items-center justify-center md:w-2/3 py-5 md:py-10 px-2 bg-palo-alto-dark text-gray-100">
					<p class="text-left font-extralight font-sanstext-xl md:text-2xl lg:text-3xl px-[calc(4rem+0.1*(100%-768px))]">
						Palo Alto Data Group takes a holistic approach to jobsite safety,
						combining technology, education, and labor standards enforcement to create a safer and more efficient workplace.
					</p>
				</div>
				<div class="hidden md:visible md:flex flex-col text-center font-extralight justify-center space-y-4 items-center w-1/3
					bg-palo-alto-light text-gray-100 px-[calc(2rem+0.1*(100%-768px))]">
					<h2 class="font-sans text-xl md:text-2xl lg:text-4xl xl:text-4xl 2xl:text-4xl">
						ENGINEERING<br>and<br>DEVELOPMENT
					</h2>
					<p class="font-sans text-sm lg:text-md xl:text-lg font-normal">
					</p>
				</div>
			</div>
			<div class="flex flex-col space-y-6 md:space-y-0 md:flex-row md:space-x-6 h-1/3 w-full">
				<div class="subsection-container">
					<h2 class="subsection-title">
						MISSION
					</h2>
					<p>
						PADG's mission is to create a safer jobsite through technology and tech education,
						allowing employers to create a better project plan—one that adheres to labor standards,
						environmental health, and workplace safety goals. Instead of approaching technology and
						workplace safety as separate issues, we aim to address these problems at their root: by focusing
						on education on all levels, communication will be greatly improved.
					</p>
					<!-- <button class="text-blue-500 max-w-max border-0">
						VIEW MORE
					</button> -->
				</div>
				<div class="subsection-container">
					<h2 class="subsection-title">
						VISION
					</h2>
					<p>
						Our work seeks to leverage technology to form an integrated foundation for a long-term AI
						solution to workforce education and jobsite safety. 
					</p>
					<!-- <a class="text-blue-500 max-w-max border-0">
						VIEW MORE
					</a> -->
				</div>
				<div class="subsection-container">
					<h2 class="subsection-title">
						RESULTS
					</h2>
					<p>
						Our work integrates workforce technology education through four main branches:
						a workforce education program teaching VDC technology and best practices, intuitive
						infrastructure BIM software that workers and employers can understand and use, labor standards
						enforcement software such as our eCPR downloader, and an app providing resources for workers to know
						their rights and protections.
					</p>
					<!-- <a class="text-blue-500 max-w-max border-0">
						VIEW MORE
					</a> -->
				</div>
			</div>
		</div>
	</div>
	<!--Third Screen-->
	<div id="products" class="relative w-full min-h-screen">
		<div class="relative flex flex-col w-full h-auto min-h-screen z-20">
			<div class="flex flex-col items-center justify-center space-y-4 md:space-y-12 h-1/2">
				<h1 class="font-roboto-slab pt-6 md:pt-14 text-xl sm:text-2xl md:text-4xl text-gray-100 text-center">
					Browse Our Products
				</h1>
				<!-- DESKTOP VIEW -->
				<div class="hidden xl:visible xl:flex md:space-x-4 flex-wrap mx-10 min-h-full max-w-[calc(2/3+0.2*(100%-1280px))]">
					{#each products as [title, svg_link, alt_text, href_link, blurb], ind}
						<div class="allow-text-selection {productExpanded[ind] ? "flex-[3]" : "flex-[1]"} overflow-auto bg-gray-100">
							<a href={href_link}>
								<button class="flex flex-col justify-center items-center space-y-3 w-full h-full px-4 py-6 lg:px-9 lg:py-8"
									on:mouseenter={() => {
										for (let i = 0; i < products.length; i++) {
											productExpanded[i] = false
										}
										productExpanded[ind] = true;
									}}>
									<img class="logo h-12 w-12" src={svg_link} alt={alt_text}>
									<p class=" text-palo-alto-dark font-semibold">
										{title}
									</p>
									{#if productExpanded[ind]}
										<p class="mx-5 pb-3 text-gray-700">
											{blurb}
										</p>
									{/if}
								</button>
							</a>
						</div>
					{/each}
				</div>
				<!-- MOBILE VIEW -->
				<div class="flex flex-col xl:hidden space-y-4 flex-wrap mx-10 min-h-full w-4/5">
					{#each products as [title, svg_link, alt_text, href_link, blurb], ind}
						<div class="flex flex-row flex-nowrap bg-gray-100">
							<div class="allow-text-selection {productExpanded[ind] ? "flex-[3]" : "flex-[1]"} overflow-auto">
								<a href={href_link}>
									<button class="flex flex-col justify-center items-center space-y-3 w-full h-full px-4 py-6 lg:px-9 lg:py-8">
										<img class="logo h-12 w-12" src={svg_link} alt={alt_text}>
										<p class=" text-palo-alto-dark font-semibold">
											{title}
										</p>
										{#if productExpanded[ind]}
											<p class="mx-5 pb-3 text-gray-700">
												{blurb}
											</p>
										{/if}
									</button>
								</a>
							</div>
							<button class="inline-flex -ml-14 w-14 h-14 border-palo-alto-dark" on:mouseup={() => {
									productExpanded[ind] = !productExpanded[ind];
							}}>
								<svg version="1.1" class="inline-block" role="presentation" viewBox="94 147 307 307" style="font-size:431.92422485px;font-style:normal;font-weight:normal;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;">
									<path id="path-0" d="M 241.99219,407.91016 L 241.99219,310.44922 L 144.72656,310.44922 L 144.72656,294.43359 L 241.99219,294.43359 L 241.99219,197.36328 L 257.61719,197.36328 L 257.61719,294.43359 L 355.27344,294.43359 L 355.27344,310.44922 L 257.61719,310.44922 L 257.61719,407.91016 L 241.99219,407.91016 z"></path>
								</svg>
							</button>
						</div>
					{/each}
				</div>
			</div>
			<div id="contact" class="mt-auto px-[calc(1rem+0.15*(100%-768px))] py-8 h-1/2 w-full bg-palo-alto-dark">
				<div class="flex flex-col md:flex-row justify-between md:space-x-4 py-10 px-10 text-gray-100">
					<div class="flex flex-col">
						<img class="logo h-32 mr-auto" src="./ref/PADG-icon-dual-lockup.svg" alt="Palo Alto Data Group Logo"/>
						<div class="flex flex-col justify-end md:justify-between space-y-2 md:space-y-4">
							<!-- Address Removed.
							<p class="self-start">	
							</p>
							-->
							<div class="flex flex-col xl:flex-row justify-end md:justify-between">
								<p>
									+1 (40<span class="hidden">9</span>8) 4<span class="hidden">28</span>75-64<span class="hidden">1</span>50
								</p>
								<p>
									information<span class="hidden">+spamfilter</span>[at]paloaltodatagroup.com
								</p>
							</div>
						</div>
					</div>
					<div class="flex flex-col space-y-4 pt-8 md:pt-6">
						<div class="flex flex-col space-y-4 lg:space-y-0 lg:flex-row lg:justify-between lg:space-x-8">
							<div class="flex flex-row space-x-2 lg:space-x-0 lg:flex-col lg:space-y-2">
								{#each links as [id, name]}
									<button class="visited:text-gray-100 border-none text-left" on:click={() => {
										document.getElementById(id).scrollIntoView({'behavior': 'smooth'});
									}}>
										{name}
									</button>
								{/each}
							</div>
							<div class="flex space-x-2 lg:space-x-0 lg:flex-col lg:space-y-2 no-underline">
								<!-- <a>Facebook</a> -->
								<!-- <a>Twitter</a> -->
								<a class="gray-link" href="https://www.linkedin.com/company/palo-alto-data-group">Linkedin</a>
								<!-- <a>Instagram</a> -->
							</div>
						</div>
						<p class="md:self-end md:!mt-auto">
							© 2021-{new Date().getFullYear()} PALO ALTO DATA GROUP. All rights reserved.
						</p>
					</div>
					<div class="mt-8 md:mt-0 self-center">
						<button class="rounded-full w-16 h-16 border-none" on:click={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
							<img class="logo h-full w-full" src="./ref/backtotop.svg" alt="Arrow pointing up">
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="absolute top-0 color-filter h-full w-full">
			<Image class="w-full h-full [&_img]:!h-full [&_img]:object-cover md:!hidden" src="./ref/footer_bg_mobile.png" alt="Image of a building under construction with a crane"/>
			<Image class="w-full h-full [&_img]:!h-full [&_img]:object-cover !hidden md:!block" src="./ref/footer_bg.png" alt="Image of a building under construction with a crane"/>
		</div>
	</div>
</main>

<style>
	.color-filter:after {
		content: '';
		background:theme("colors.palo-alto.light");
			@apply absolute z-10 top-0 left-0 opacity-50 w-full h-full;
	}

	.color-filter img {
		/* -webkit-filter: grayscale(100%);
		filter: grayscale(100%); */
		@apply z-10;
	}

	.subsection-container {
		@apply flex flex-col pb-4 space-y-2 md:space-y-4 md:w-1/3;
	}

	.subsection-title {
		@apply font-semibold text-2xl lg:text-3xl xl:text-3xl text-olive-light;
	}

	.gray-link:link, .gray-link:visited {
		@apply text-gray-200;
	}

	.allow-text-selection {
		-webkit-user-select: text;
		-moz-user-select: text;
		-ms-user-select: text;
		user-select: text;
	}
</style>